
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industry/real-estate/whatsapp",
      function () {
        return require("private-next-pages/industry/real-estate/whatsapp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industry/real-estate/whatsapp"])
      });
    }
  